import type { Selection } from '@tiptap/pm/state';
import type { Editor } from '@tiptap/react';
import { useContext, useEffect, useState } from 'react';
import { EditorContext, ModalContext } from 'ricos-context';

export type UseFloatingToolbarParams = {
  getIsVisible: (selection: Selection) => boolean;
  onSelectionChange?: (editor: Editor) => void;
};

export const useFloatingToolbar = ({
  getIsVisible,
  onSelectionChange,
}: UseFloatingToolbarParams) => {
  const {
    adapter: { tiptapEditor },
  } = useContext(EditorContext);
  const modalService = useContext(ModalContext);
  const [showFloatingToolbar, setShowFloatingToolbar] = useState(
    getIsVisible(tiptapEditor.state.selection)
  );

  useEffect(() => {
    const onSelectionUpdate = () => {
      setShowFloatingToolbar(getIsVisible(tiptapEditor.state.selection));
      onSelectionChange?.(tiptapEditor);
    };

    tiptapEditor.on('selectionUpdate', onSelectionUpdate);
    const onModalToggle = () => setShowFloatingToolbar(getIsVisible(tiptapEditor.state.selection));

    const subscriptions = [
      modalService.onModalOpened(onModalToggle),
      modalService.onModalClosed(onModalToggle),
    ];

    return () => {
      tiptapEditor.off('selectionUpdate', onSelectionUpdate);
      subscriptions.forEach(sub => sub.cancel());
    };
  }, [getIsVisible]);

  return {
    showFloatingToolbar,
  };
};
